export class ReducedMealBreakFormDataDTO {
  constructor(data = {}) {
    this.option = data.option || null
    this.value = data.value || null
  }
}

export class MealBreakFormDataDTO {
  constructor(data = {}) {
    this.reducedMealBreak = data.reducedMealBreak
      ? new ReducedMealBreakFormDataDTO(data.reducedMealBreak)
      : null
  }
}
